const LoginRoute = () => import("./features/Auth/Login.vue");
const MainRoute = () => import("./features/Main/Main.vue");
const DashboardRoute = () => import("./features/Main/Dashboard/Dashboard.vue");
const CashierBalancingRoute = () =>
  import("./features/Main/Lists/CashierBalancing/CashierBalancing.vue");
const ConfigRoute = () => import("./features/Main/Config/Config.vue");
const ChangelogRoute = () => import("./features/Main/Changelog/Changelog.vue");
const InviteRoute = () => import("./features/Auth/Invite.vue");
const SendRecoveryPasswordRoute = () =>
  import("./features/Auth/RecoveryPassword/SendRecoveryPassword.vue");
const SetNewPasswordRoute = () =>
  import("./features/Auth/RecoveryPassword/SetNewPassword.vue");
const ZepplinRequestReportRoute = () =>
  import("./features/Main/Lists/ZepplinRequestReport/ZepplinRequestReport.vue");
const MasterMainRoute = () => import("./features/MasterMain/MasterMain.vue");
const CompanyRequestMonitoringRoute = () =>
  import("./features/MasterMain/CompanyRequestMonitoring/CompanyRequestMonitoring.vue");
const CreateCompaniesRoute = () =>
  import("./features/MasterMain/CreateCompanies/CreateCompanies.vue");
const CompaniesListRoute = () =>
  import("./features/MasterMain/CompaniesList/CompaniesList.vue");
const SendNotificationsRoute = () =>
  import("./features/MasterMain/SendNotifications/SendNotifications.vue");
const DeliverymenListRoute = () =>
  import("./features/MasterMain/DeliverymenList/DeliverymenList.vue");
const ManageProductsRoute = () =>
  import("./features/MasterMain/ManageProducts/ManagerMain.vue");
const CreateDeliverymenRoute = () =>
  import("./features/MasterMain/CreateDeliverymen/CreateDeliverymen.vue");
const Coupons = () => import("./features/MasterMain/Coupons/Coupons.vue");
const CreateCoupons = () => import("./features/MasterMain/Coupons/Create.vue");
const EditCoupon = () => import("./features/MasterMain/Coupons/Edit.vue");

export default [
  {
    path: "/login",
    component: LoginRoute,
    meta: {
      title: "Login - GestaON",
    },
  },
  {
    path: "/invite/:inviteKey",
    component: InviteRoute,
    meta: {
      title: "Tornar-se membro - GestaON",
    },
  },
  {
    path: "/recovery-password",
    component: SendRecoveryPasswordRoute,
    meta: {
      title: "Recuperar senha - GestaON",
    },
  },
  {
    path: "/recovery-password/:recoveryKey",
    component: SetNewPasswordRoute,
    meta: {
      title: "Nova senha - GestaON",
    },
  },
  {
    path: "/master/",
    component: MasterMainRoute,
    children: [
      {
        path: "company-request-monitoring",
        component: CompanyRequestMonitoringRoute,
        meta: {
          title: "Monitoramento de pedidos Zepplin - GestaON Master",
        },
      },
      {
        path: "companies",
        component: CompaniesListRoute,
        meta: {
          title: "Empresas - GestaON Master",
        },
      },
      {
        path: "deliverymen",
        component: DeliverymenListRoute,
        meta: {
          title: "Entregadores Zepplin - GestaON Master",
        },
      },
      {
        path: "create-companies",
        component: CreateCompaniesRoute,
        meta: {
          title: "Criar empresas - GestaON Master",
        },
      },
      {
        path: "send-notifications",
        component: SendNotificationsRoute,
        meta: {
          title: "Enviar notificações - GestaON Master",
        },
      },
      {
        path: "manage-products",
        component: ManageProductsRoute,
        meta: {
          title: "Gerenciar produtos Zepplin - GestaON Master",
        },
      },
      {
        path: "create-zepplin-deliverymen",
        component: CreateDeliverymenRoute,
        meta: {
          title: "Criar entregadores Zepplin - GestaON Master",
        },
      },
      {
        path: "coupons",
        component: Coupons,
        meta: {
          title: "Cupons de desconto - GestaON Master",
        },
      },
      {
        path: "create-coupon",
        component: CreateCoupons,
        meta: {
          title: "Criar Cupom - GestaON Master",
        },
      },
      {
        path: "edit-coupon/:id",
        component: EditCoupon,
        meta: {
          title: "Editar Cupom - GestaON Master",
        },
      },
    ],
  },
  {
    path: "/",
    component: MainRoute,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardRoute,
        meta: {
          title: "Painel de pedidos - GestaON",
        },
      },
      {
        path: "cashier-balancing",
        component: CashierBalancingRoute,
        meta: {
          title: "Caixa / Fechamento diário - GestaON",
        },
      },
      {
        path: "zepplin-request-report",
        component: ZepplinRequestReportRoute,
        meta: {
          title: "Relatório de vendas do Zepplin - GestaON",
        },
      },
      {
        path: "config",
        component: ConfigRoute,
        meta: {
          title: "Configurações do sistema - GestaON",
        },
      },
      {
        path: "changelog",
        component: ChangelogRoute,
        meta: {
          title: "Novidades dessa versão - GestaON",
        },
      },
      {
        path: "*",
        redirect: "/dashboard",
      },
    ],
  },
  {
    path: "*",
    redirect: "/dashboard",
  },
];
